import { FC } from 'react';
import { ContactInfo } from './contact-info/contact-info';
import { FullScreenExit, HeaderWrapper } from './header.styles';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { usePatientProfile } from 'apps/wrapper/src/hooks/use-patient-profile';
import { EventPatientProfile } from '@revenuewell/logic-wrapper-proxy';
import { useHistory } from 'react-router-dom';

export const PatientProfileHeader: FC = () => {
  const { publish } = useEventBus();
  const { contactDetails, locationId } = usePatientProfile();
  const history = useHistory();


  const handleExit = () => {
    publish({
      messageType: 'patientProfile',
      data: {
        patientId: contactDetails.id,
        locationId,
      } as EventPatientProfile['data']
    });
    const urlParams = new URLSearchParams(history.location.search);
    const backTo = urlParams.get('backTo');
    if (backTo) {
      history.replace(backTo);
    } else {
      history.goBack();
    }
  };

  return (
    <HeaderWrapper>
      <ContactInfo />
      <FullScreenExit onClick={handleExit}>
        <FullscreenExitIcon />
      </FullScreenExit>
    </HeaderWrapper>
  );
};
